<template>
  <b-modal id="latestBidsModal" static ok-only :ok-title="$t('Close')"
           size="lg"
           @show="onModalShow"
           @close="$emit('input', false)">
    <template #modal-header="{ close }">
      <h5 class="modal-title">{{ $t('Latest Bids') }}</h5>
      <ModalCloseButton @click="close" />
    </template>
    <ModalLotDetails :lot="lot" />
    <table class="table table-sm table-bordered mb-0">
      <thead>
      <tr>
        <th class="col-auto">{{ $t('Auto') }}</th>
        <th class="col-number">{{ $t('Number') }}</th>
        <th v-for="key of customerAdditionalColumns" :key="key"
            :class="'col-customer_' + key">
          {{ $t('latestBids.customer_' + key) }}
        </th>
        <th class="col-amount">{{ $t('Amount') }}</th>
        <th class="col-date">{{ $t('Date/Time') }}</th>
      </tr>
      </thead>
      <tbody v-if="lot.last_bids && lot.last_bids.length">
      <tr v-for="bid in lot.last_bids" :key="bid.id"
          :class="bid.customer_uuid === customer.uuid ? 'font-weight-bold' : ''">
        <td class="col-auto">{{ bid.auto_bid ? 'A' : '-' }}</td>
        <td class="col-number">{{ bid.paddle_no }}{{ bid.customer_uuid === customer.uuid ? ' (' + $t('me') + ')' : ''}}</td>
        <td v-for="key of customerAdditionalColumns" :key="key" :class="'col-customer_' + key">
          {{ bid['customer_' + key] }}
        </td>
        <td class="col-amount">{{ bid.amount | asCurrency(lot.currency.code) }}</td>
        <td class="col-date">{{ (bid.bid_date || bid.created_at) | datetimeWithSeconds }}</td>
      </tr>
      </tbody>
      <tbody v-else>
      <tr>
        <td :colspan="4 + customerAdditionalColumns.length" class="text-muted text-center py-3">
          {{ $t('There are no bids on this lot') }}
        </td>
      </tr>
      </tbody>
    </table>
    <div class="ta-lot-latest-bids-load-more-wrapper mt-2" v-if="lot && lot.last_bids && lot.num_of_bids > lot.last_bids.length">
      <b-spinner small class="mt-1 mr-2" v-if="loading"></b-spinner>
      <a href="#" @click.prevent="loadMore()">{{$t('Load More')}}</a> 
    </div>
    <small class="ta-automatic-bid-explanation">{{ $t('A - Automatic Bid placed through Max Bid') }}</small>
  </b-modal>
</template>

<script>
import {mapState, mapActions, mapGetters} from "vuex";
import lotBiddingMixin from "../../mixins/lotBiddingMixin";
import thumbnailMixin from "@/mixins/thumbnailMixin";
import ModalLotDetails from "@/components/core/ModalLotDetails";
import ModalCloseButton from "@/components/core/ModalCloseButton";
import {viewBidHistory} from "@/triggers";
import lotHelperMixin from "@/mixins/lotHelperMixin";

export default {
  name: "LatestBidsModal",
  components: {ModalCloseButton, ModalLotDetails},
  mixins: [lotBiddingMixin, thumbnailMixin, lotHelperMixin],
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapState(['mainConfig', 'settings', 'customer']),
    ...mapState({
      lot: state => state.lotObject.data
    }),
    ...mapGetters(['customerAdditionalColumns']),
  },
  methods: {
    ...mapActions(['loadLotBids']),

    onModalShow() {
      viewBidHistory(this.title)
    },
    loadMore() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.loadLotBids().then(res => {
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped lang="scss">
.ta-lot-latest-bids {
  font-size: 90%;
}

.ta-automatic-bid-explanation {
  display: block;
  margin: 1rem 0;
}

.ta-lot-latest-bids-load-more-wrapper{
  display: flex;
  justify-content: center;
}

</style>

<style lang="scss">
@import "../../bootstrap/import";

</style>
